import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [

    {
        path: '', title: 'Solicitações', icon: 'ft-alert-circle', class: '', badge: '', badgeClass: '', isExternalLink: false,   isBtn: true, actionBtn: 'filtroSolicitacao', submenu: []
    },
    {
        path: '', title: 'Efetivo', icon: 'ft-user-check', class: '', badge: '', badgeClass: '', isExternalLink: false,   isBtn: true, actionBtn: 'filtroEfetivoPronto', submenu: []
    },

];



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar-routes.config.ts